module.exports = __webpack_public_path__ + "img/contact-header.9b8d9155.jpg";